export default __webpack_public_path__ + "static/media/anonymous-user.4af293fb.svg";